import { render } from "./BindBankCard.vue?vue&type=template&id=9d60e8d0&scoped=true"
import script from "./BindBankCard.vue?vue&type=script&lang=js"
export * from "./BindBankCard.vue?vue&type=script&lang=js"

import "./BindBankCard.vue?vue&type=style&index=0&id=9d60e8d0&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d60e8d0"]])

export default __exports__